<!--
 * @Author: 
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-11 17:14:13
 * @Description: 这是顶部的导航栏
-->
<template>
    <q-header elevated class="header-wrap fixed">
        <q-toolbar class="h-full">
            <div class="left-part truncate">
                <!-- ↓ 导航栏左上角的关键图标（按钮） -->
                <div class="user-box" v-show="hasUserLogged">
                    <UserAvatar
                        self
                        size='35px'
                    ></UserAvatar>
                    <i class="unread" v-if="iUnreadNum">
                        <ClientOnly>
                            {{ iUnreadNum > 99 ? '99+' : iUnreadNum }}
                        </ClientOnly>
                    </i>
                    <span class="user-info">
                        <span class="user-name truncate">
                            {{ userStore.name }}
                        </span>
                        <span class="user-id truncate">
                            {{ $t('commonInfo.userId') + ` ${userStore.id}` }}
                        </span>
                    </span>
                </div>
                <!--
                    ↑ 头像
                    ↓ 头像的菜单
                -->
                <q-menu :offset="[0, 10]"
                    width="235px"
                    max-height="550px"
                    v-model="showCollapse"
                    :style="{ background: 'transparent' }"
                >
                    <div class="panel text-white">
                        <div class="user-board">
                            <UserAvatar
                                self
                                size='70px'
                                @click="fnChangeAvatarPic"
                            ></UserAvatar>
                            <span class="editing-wrap"
                                @click="fnChangeAvatarPic"
                            >
                                <q-icon name="border_color"
                                    class="text-white"
                                />
                            </span>
                            <span class="level">
                                {{ (userStore.lvl ?? 1) }}
                                {{ $t('menuAndBtn.rank') }}
                            </span>
                            <em class="name truncate">
                                {{ userStore.name }}
                            </em>
                        </div>
                        <!-- ↑ 头像图，等级，用户名等 -->
                        <div class="user-menu">
                            <ul class="vertical-menu__inner">
                                <li class="vertical-menu__item" v-for="(cur, idx) of aMenuArr" :key="idx">
                                    <NuxtLink v-if="cur.i18nKey == 'headerMenu.HomePage'"
                                        class="vertical-menu__link"
                                        :to="getLocalPath(cur.to)"
                                        :prefetch="cur.prefetch"
                                    >
                                        <IconSvgUse class="vertical-menu__icon"
                                            size="24px"
                                            :use="cur.iconName"
                                            preserveAspectRatio="xMidYMid meet"
                                        />
                                        <span>
                                            {{ $t(cur.i18nKey) }}
                                        </span>
                                        <i class="menu-unread" v-if="cur.to.includes('/notification') && iUnreadNum">
                                            {{ iUnreadNum }}
                                        </i>
                                    </NuxtLink>
                                    <div v-else class="vertical-menu__link"
                                        @click="tabClick(cur.i18nKey); showCollapse = false">
                                        <IconSvgUse class="vertical-menu__icon" size="24px" :use="cur.iconName"
                                            preserveAspectRatio="xMidYMid meet" />
                                        <span>
                                            {{ $t(cur.i18nKey) }}
                                        </span>
                                        <i class="menu-unread" v-if="cur.to.includes('/notification') && iUnreadNum">
                                            {{ iUnreadNum }}
                                        </i>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <!-- 分界 -->
                        <div class="user-menu">
                            <ul class="vertical-menu__inner">
                                <li class="vertical-menu__item">
                                    <DropDown v-model="UILang" :options="options" class="selecter" :shadow="true">
                                        <template #prevIcon>
                                            <IconSvgUse size="25px" use="icon-menu-networks"
                                                class="vertical-menu__icon" />
                                        </template>
                                    </DropDown>
                                </li>
                                <li class="vertical-menu__item">
                                    <button class="vertical-menu__link">
                                        <IconSvgUse use="icon-sound" size="24px" class="vertical-menu__icon" />
                                        &nbsp;{{ $t('music.Music') }}
                                        <Toggle class="ml-auto" color="green" v-model="settingStore.globalSounds">
                                        </Toggle>
                                    </button>
                                </li>
                                <li class="vertical-menu__item">
                                    <button class="vertical-menu__link">
                                        <IconSvgUse use="icon-animation-new" size="24px" class="vertical-menu__icon" />
                                        &nbsp;{{ $t('commonInfo.Animation') }}
                                        <Toggle class="ml-auto" color="green" v-model="settingStore.animation"></Toggle>
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <!-- ↓设备信息 -->
                        <div class="device">
                            {{ $t('menuAndBtn.version') }}:
                            {{ oBrowser.name + ' ' + oBrowser.version }}
                            v{{ sBuiltAt }}
                        </div>
                        <!-- ↓ 以下是调试功能 -->
                        
                    </div>
                </q-menu>
            </div>
            <!-- 
                左右分界
            -->
            <div class="right-part flex justify-center items-center gap-[15px] h-[36px]">
                <!-- ▼用户余额等 -->
                <HeaderWallet
                    v-show="userStore.isLoggedIn"
                    @openAccountModel="accountHistoryShow = true"
                ></HeaderWallet>
                <!-- ▼登录/注册按钮（仅调试中可见）-->
                
            </div>
        </q-toolbar>
    </q-header>
    <!-- 
        以下是浮层与弹窗 
    -->
    <GameHistory v-if="gameHistoryShow" v-model:show="gameHistoryShow" />
    <Notification v-if="notificationShow" v-model:show="notificationShow" />
    <AccountHistory v-if="accountHistoryShow" v-model:show="accountHistoryShow" />
    <!-- ↓ 修改头像窗口 --> 
    <ModalAvatarManagement 
        v-if="bAvatarManagementVisible"
        v-model="bAvatarManagementVisible"
    />
</template>

<script lang="ts">
export default {
    name: 'HeaderOnTop',
}
</script>

<script lang="ts" setup>
import { useUserStore } from '@/stores/user';
import useGlobalStore from '@/stores/global';
import useSettingsStore from '@/stores/settings';
import { toRecordNewLanguage } from '@/i18n/langSettingFn';
import { useAuthStore } from '~/stores/auth';
import { useJoinStateStore } from '@/stores/cansino/joinState';
import { useAutoOptionStore } from '~/stores/cansino/autoOption';

const authStore = useAuthStore();
const settingStore = useSettingsStore();
const globalStore = useGlobalStore();
const userStore = useUserStore();
const { t: $t, locale } = useI18n();
const joinStateStore = useJoinStateStore()
interface LangOption {
    label: string;
    value: string;
    name: string;
}

const router = useRouter();
// 监听路由，路由不同关闭浮层
router.beforeEach((to, from) => {
    if (from.path == to.path) {
        return
    }
    if (gameHistoryShow.value) gameHistoryShow.value = false
    if (notificationShow.value) notificationShow.value = false
    if (accountHistoryShow.value) accountHistoryShow.value = false
})
const route = useRoute(); 
const showCollapse = ref(false);
const bAvatarManagementVisible = ref(false);
const localPath = useLocalePath();
const sBuiltAt = import.meta.env.BUILT_AT;
const oBrowser = ref({
    name: '',
    version: '',
});
const options: LangOption[] = reactive([{
    label: $t('lang.en'),
    value: 'en',
    name: $t('lang.en'),
    // icon: 'flag-en', // ← 修改后似乎无用了，留院观察，将来删除 2024.07.05 17:0:19 星期五  
}, {
    label: $t('lang.cn'),
    value: 'cn',
    name: $t('lang.cn'),
    // icon: 'flag-cn',
}]);


// ↓菜单 
const aMenuArr = [{
    i18nKey: 'headerMenu.notification',
    iconName: 'icon-bell-full',
    to: '/account/notification',
    prefetch: true,
},
{
    i18nKey: 'headerMenu.AccountStatement',
    iconName: 'menu-deposit-history', // icon-transaction
    to: '/account/accountHistory',
    prefetch: true,
},
{
    i18nKey: 'headerMenu.GameHistory',
    iconName: 'menu-game-history', // icon-history 
    to: '/account/gameHistory',
    prefetch: true,
}, {
    i18nKey: 'headerMenu.HomePage',
    iconName: 'icon-virtual-sport',
    to: '/',
    prefetch: false,
},];

// ↓通知
const notificationShow = ref(false)
// ↓游戏历史记录
const gameHistoryShow = ref(false)
// ↓资金记录
const accountHistoryShow = ref(false)

const hasUserLogged = computed(() => {
    // Mini 版默认用户已经登录 
    if (import.meta.server) {
        return true;
    }
    return !!userStore.isLoggedIn;
});

const iUnreadNum = computed(() => {
    const {
        system = 0,
        person = 0,
    } = userStore.unread;
    return system + person;
});

const UILang = computed({
    get: () => locale.value,
    set: async (sNewLang) => {
        showCollapse.value = false;
        console.log(`语言切换方向 ${locale.value} ➡️ ${sNewLang}`); 
        // ↓ 切换语言需要关停自动模式，重要！ 
        if (locale.value != sNewLang){
            const autoOption = useAutoOptionStore();
            autoOption.isAutoBetting = false;
        }
        await Sleep(150);
        const newURL = localPath(
            router.currentRoute.value.fullPath,
            sNewLang,
        );
        router.push({
            replace: true, // 执行覆盖，防止切换语言后点击返回按钮出错  
            path: newURL,
            query: route.query,
        });
        toRecordNewLanguage(sNewLang);
    },
});

// 打开弹窗
const tabClick = (name) => {
    switch (name) {
        // 通知弹窗
        case 'headerMenu.notification':
            notificationShow.value = true
            break
        // 游戏记录弹窗
        case 'headerMenu.GameHistory':
            gameHistoryShow.value = true
            break
        // 资金记录
        case 'headerMenu.AccountStatement':
            accountHistoryShow.value = true
            break
    }
}

/**
 * 更换头像（显示窗口）
 * @description: 切换头像
 */
const fnChangeAvatarPic = async ()=>{
    showCollapse.value = false; 
    await nextTick(); 
    bAvatarManagementVisible.value = true;
}


function getBrowserDetails() {
    const ua = navigator.userAgent;
    let tem, M = ua.match(/(opera |chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return { name: 'IE', version: tem[1] || '' };
    }

    if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR |Edge)\/(\d+)/);
        if (tem != null) return { name: tem[1].replace('OPR', 'Opera'), version: tem[2] };
    }

    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
    }

    return {
        name: M[0],
        version: M[1]
    };
}

watch(
    () => settingStore.globalSounds,
    (newVal) => {
        settingStore.inhouseGames.sound.on = !!newVal;
    },
);

/**
 * 登录（用于测试） 
 */
const toLogIn4Test = async () => {
    showCollapse.value = false;
    await nextTick();
    globalStore.loginDialogIsOpen = true;
};

/**
 * 退出登录（用于测试） 
 */
async function userLogOut() {
    showCollapse.value = false;
    await nextTick();
    // ↓ 后端来信：对,mini版注册登录相关的接口都屏蔽了 2025.01.24 13:35:23 星期五
    // const res = await POST_LOGOUT();
    // const arr = [
    //     [0, '0'].includes(res?.statusCode), // 通常返回 Number 型的 0 
    //     res?.message?.includes('退出成功'),
    //     res?.message?.includes('Logout success'),
    //     res?.error === '未登录',
    // ];
    // // console.log("log out: ", arr.some(Boolean));
    // if (arr.some(Boolean)) {
    //     authStore.cleanToken();
    //     location.reload();
    // }
    authStore.cleanToken();
    location.reload();
}


onMounted(async () => {

    // const {hasLogged} = await getUserInfo();
    // hasUserLogged.value = Boolean(hasLogged);
    try {
        const res = getBrowserDetails();
        oBrowser.value.name = res?.name || '';
        oBrowser.value.version = res?.version || 'v0';
    } catch (err) {
        console.error('查询浏览器信息未成功', err);
    }
});


</script>

<style scoped lang="scss">
.header-wrap {
    height: var(--header-height);
    z-index: 99;
    background: rgba(16, 22, 34, 1);
    padding-top: env(safe-area-inset-top, 0px);
    box-sizing: border-box;
    .q-toolbar {
        min-height: var(--header-height);
    }
}

.left-part {
    flex-grow: 0;
    flex-shrink: 1;
    overflow: hidden;
    padding-right: 10px;
    min-width: 0;
    // width: 100%; 
    // max-width: 100%; 
}

.user-box {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    flex-direction: row;
    cursor: pointer;
    overflow: hidden;
    position: relative;
    .unread {
        display: inline-block;
        align-self: flex-start;
        margin: 0 5px 0 -20px;
        z-index: 2;
        --size: 14px;
        height: var(--size);
        min-width: var(--size);
        line-height: var(--size);
        text-align: center;
        font-size: 10px;
        border-radius: calc(var(--size) * 0.5);
        background: rgba(27, 184, 61, 1);
        border: 0.7px solid rgba(27, 38, 54, 1);
        padding: 0 2px;
    }
    .user-avatar {
        border: solid 3px var(--bg007);
        flex-shrink: 0;
        margin-right: 8px;
    }
}


.user-info {
    display: flex;
    align-content: flex-start;
    justify-content: center;
    flex-direction: column;
    line-height: 1.3;
    min-width: 0; // 允许在flex容器中收缩
    max-width: 100%; // 限制最大宽度

    .user-name,
    .user-id {
        white-space: nowrap; // 确保单行显示
        display: block; // 针对column布局需要block显示
    }

    .user-name {
        font-weight: 600;
        font-size: 14px;
        color: white;
    }

    .user-id {
        color: var(--bg005);
        font-weight: 600;
        font-size: 10px;
    }
}

.right-part {
    margin-left: auto;
    flex-shrink: 0;
    flex-grow: 1;
    justify-content: flex-end;
}

.user-board {
    display: flex;
    justify-content: center;
    flex-wrap: nowrap;
    flex-direction: column;
    align-items: center;
    margin: 0 0 12px;
    position: relative; 
    .user-avatar {
        border: solid 4px #2A3546; 
    }
    .editing-wrap{
        position: absolute; 
        top: 0;
        left: calc(50% + 10px);
        width: 19px;
        height: 19px;
        border-radius: 100px;
        background: #000000CC;
        display: flex;
        justify-content: center; 
        align-items: center; 
        .q-icon{
            font-size: 10px;
        }
    }
    .level {
        background: rgba(237, 29, 73, 1);
        margin: -5px 0 5px;
        min-width: 50px;
        height: 20px;
        border-radius: 40px;
        padding: 0 10px;
    }

    .name {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        max-width: 95%;
    }
}


.panel {
    width: 235px;
    padding: 20px 10px 25px;
    background: rgba(28, 37, 50, 1);
    box-shadow: 0px -10px 30px 0px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
}

.user-menu {
    width: 100%;
    background-color: #2e3c50;
    border-radius: 10px;
    margin: 0 0 10px;
}


.user-menu {
    min-height: 50px;

    ul.vertical-menu__inner {
        padding: 6px 0;

        li.vertical-menu__item {
            margin: 0 10px;

            &+li {
                border-top: solid 1px rgba(255, 255, 255, 0.1);
            }
        }
    }
}

.vertical-menu__link {
    align-items: center;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    // color: #93acd3;
    color: rgba(167, 181, 202, 1);
    cursor: pointer;
    display: inline-flex;
    font-size: 14px;
    font-weight: 600;
    justify-content: flex-start;
    line-height: 1.5;
    padding: 6px 6px;
    position: relative;
    text-align: center;
    text-decoration: none;
    transition: color .1s ease-in-out, background-color .1s ease-in-out;
    vertical-align: middle;
    white-space: nowrap;
    width: 100%;

    &.active,
    &:hover {
        color: #fff
    }
}

.vertical-menu__icon {
    margin-right: 8px;
    fill: #55657E;
    color: #55657E;
}

.menu-unread {
    display: inline-block;
    min-width: 20px;
    height: 20px;
    line-height: 18px;
    margin: 0 0 0 6px;
    padding: 0 5px;
    border: solid 1px rgba(27, 38, 54, 1);
    border-radius: 5px;
    background: rgba(27, 184, 61, 1);
    color: white;
    font-weight: 700;
    font-size: 12px;
    text-align: center;
    vertical-align: middle;
}

// ↓语言选择器 
.selecter {
    background-color: transparent;
    color: rgba(167, 181, 202, 1);
    margin-left: -3px;

    :deep() {
        .main-title {
            color: inherit !important;
            font-size: 14px;
        }

        .svg-use[class*=duration] {
            color: inherit !important;
            width: 25px;
            height: 25px;
        }
    }
}

.device {
    font-size: 10px;
    color: #A7B5CA;
    margin: 0px 0 0;
}
</style>
